import { useEffect, useState } from 'react';
import { client } from '../../api/Api';

interface AdminStats {
    productsCount: number;
    productsWithDescriptionsCount: number;
    recipesCount: number;
    pricesCount: number;
    categoriesCount: number;
    pgvectorInfo: string;
}

interface ServerAdminStatsDTO {
    totalProducts: number;
    withDescription: number;
    withoutDescription: number;
    recipesCount: number;
    pricesCount: number;
    pgvectorCount?: number;
    pgvectorLatest?: string | null;
}

const useAdminStats = () => {
    const [stats, setStats] = useState<AdminStats>({
        productsCount: 0,
        productsWithDescriptionsCount: 0,
        recipesCount: 0,
        pricesCount: 0,
        categoriesCount: 0,
        pgvectorInfo: 'N/A',
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchStats = async () => {
            setLoading(true);
            setError(null);
            try {
                // Use consolidated admin stats endpoint and map to UI fields
                const [adminStatsRes, categoriesRes] = await Promise.all([
                    client.get<ServerAdminStatsDTO>('/admin/stats'),
                    client.get<number>('/categories/count').catch(() => ({ data: 0 } as any)),
                ]);

                const admin = adminStatsRes.data || ({} as ServerAdminStatsDTO);

                const latest = admin.pgvectorLatest ? new Date(admin.pgvectorLatest) : null;
                const latestStr = latest ? latest.toLocaleString() : 'nėra';
                const pgvInfo = `Įrašų: ${admin.pgvectorCount ?? 0}${latest ? ", pask. atnaujinta: " + latestStr : ''}`;

                setStats({
                    productsCount: admin.totalProducts ?? 0,
                    productsWithDescriptionsCount: admin.withDescription ?? 0,
                    recipesCount: admin.recipesCount ?? 0,
                    pricesCount: admin.pricesCount ?? 0,
                    categoriesCount: (categoriesRes as any).data ?? 0,
                    pgvectorInfo: pgvInfo,
                });
            } catch (err) {
                setError('Unable to load dashboard statistics. Please try again later.');
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    return { stats, loading, error };
};

export default useAdminStats;